export { default } from './capitalizeFirstCharacter'
